import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=b8ff88b2&scoped=true&"
import script from "./CustomerDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomerDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=b8ff88b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff88b2",
  null
  
)

export default component.exports